/** An auth call the API refused, with the API's own code so a page can act on it, not just show it. */
export class AuthError extends Error {
  readonly code: string | undefined

  constructor(message: string, code?: string) {
    super(message)
    this.name = 'AuthError'
    this.code = code
  }
}

/** The address already has an account: the person should sign in, not try again. */
export const isEmailTaken = (error: unknown): boolean =>
  error instanceof AuthError && error.code === 'email_already_registered'
